export default "__VITE_ASSET__QJRozDw6__"